module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.6c6fb927.ttf";